module.exports = __webpack_public_path__ + "img/bicycle-picture.c5aa74fd.svg";